import { useRef, useEffect } from 'react';
import { getPixallId } from '@atc/pixall-fns';
import { useDispatch, useSelector } from 'react-redux';
import { eventBus } from '@atc/cai-event-bus';
import { usePrevious } from '@atc/use-previous';
import { useFeatures } from '@atc/features';
import { WALLET_GET_ICO_TRADE_INS_COMPLETED, WALLET_GET_ICO_TRADE_INS_REQUEST } from 'wallet-manager';
const useIcoTradeInInitialization = _ref => {
  let {
    paymentsDuck
  } = _ref;
  const dispatch = useDispatch();
  const displayModal = useSelector(paymentsDuck.selectors.getDisplayMyWalletModal);
  const tradeIn = useSelector(paymentsDuck.selectors.getTradeIn);
  const {
    configs: myWalletConfigs
  } = useSelector(paymentsDuck.selectors.getMyWallet) || {};
  const {
    ico: [enableIco],
    vrs: [enableVrs]
  } = useFeatures(['ico', 'vrs']);
  const prevDisplayModal = !!usePrevious(displayModal);
  const icoEnabled = enableIco && enableVrs;
  const fetchIcoTradeIns = async () => {
    const pixAllId = getPixallId() || 'nl';
    {
      eventBus.emit(WALLET_GET_ICO_TRADE_INS_REQUEST, {
        pixAllId,
        myWalletConfigs
      });
    }
  };

  /*
   * NOTE: The ICO trade-in fetch should happen on the initial wallet modal open,
   * or on subsequent opening of the modal if the specified timeout has expired
   */
  const tradeInsLastFetched = useRef(0);
  function updateIcoTradeIns() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (Object.keys(data).length) {
      dispatch(paymentsDuck.creators.updateUserTradeIn(data, true));
    }
  }
  useEffect(() => {
    eventBus.on(WALLET_GET_ICO_TRADE_INS_COMPLETED, updateIcoTradeIns);
    return () => {
      eventBus.off(WALLET_GET_ICO_TRADE_INS_COMPLETED, updateIcoTradeIns);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const hasIcoTradeIns = tradeIn?.ico?.length > 0;
    const timeSinceLastFetched = Date.now() - tradeInsLastFetched.current;
    const userOpenedWalletModal = !prevDisplayModal && displayModal;
    const shouldFetch = !hasIcoTradeIns && userOpenedWalletModal && timeSinceLastFetched >= 60000;
    if (icoEnabled && shouldFetch) {
      fetchIcoTradeIns();
      tradeInsLastFetched.current = Date.now();
    }
  }, [displayModal, prevDisplayModal]); /* eslint-disable-line react-hooks/exhaustive-deps */

  return {
    fetchIcoTradeIns
  };
};
export { useIcoTradeInInitialization as default };
